export const INDUSTRIES = [
  'Accounting & Auditing',
  'Aerospace & Aviation',
  'Automotive Engineering',
  'Biotechnology',
  'Blockchain & Cryptocurrency',
  'Arts & Design',
  'Cybersecurity',
  'Data Science & Artificial Intelligence',
  'Defense & Military',
  'Engineering (Civil, Mechanical, Electrical, etc.)',
  'Environmental Science & Sustainability',
  'Finance & Investment Banking',
  'Healthcare & Medical',
  'Information Technology (IT)',
  'Insurance',
  'Legal',
  'Luxury & Lifestyle',
  'Manufacturing & Industrial Automation',
  'Maritime & Shipping',
  'Oil & Gas',
  'Pharmaceuticals',
  'Real Estate Development',
  'Regulatory Compliance (e.g., FDA, GDPR)',
  'Software Development',
  'Supply Chain & Logistics',
  'Telecommunications',
  'Utilities & Energy Sector',
  'Other',
] as const;
